// @flow
import createCachedSelector from 're-reselect';

export default createCachedSelector;
